var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"size":"xl","title":"Edit Credit Group"},on:{"show":_vm.resetModal,"hidden":_vm.resetModal,"ok":_vm.handleOk},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return cancel()}}},[_vm._v("Cancel")]),_c('b-button',{staticClass:"bg-site-primary",attrs:{"size":"sm","disabled":!_vm.isFormValid ? "disabled" : null,"variant":"primary"},on:{"click":function($event){return ok()}}},[_vm._v("Update Credit Group")])]}}])},[_c('b-table',{staticClass:"align-middle",attrs:{"stacked":"","borderless":true,"fields":[
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'credits',
          label: 'Assigned Credits'
        } ],"items":[{
      name: _vm.name,
      credits: _vm.credits
    }]},scopedSlots:_vm._u([{key:"cell(name)",fn:function(){return [_c('b-form-input',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})]},proxy:true},{key:"cell(credits)",fn:function(){return [_c('b-form-input',{on:{"keypress":function($event){return _vm.filterNumberOnlyWithMax($event)}},model:{value:(_vm.credits),callback:function ($$v) {_vm.credits=$$v},expression:"credits"}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }